import { TagCheckOutlineIcon } from './TagCheckOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 1E060329-9C85-4470-8140-DD96F6877E76
 * name tag-check-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tag-check-outline.svg
 * tags
 */
export const TagApproveOutlineIcon = TagCheckOutlineIcon;
export default TagApproveOutlineIcon